import React, {Component} from 'react';
import {kNIntoTons, RoundTo1Decimal} from '../utils';

export default class PlainRopesOrderingTable extends Component {
  constructor (props) {
    super (props);
  }

  render () {
    const {orderingItems, tableType, showTDBF} = this.props;
    
    const isStretcher = tableType === 'RopeStretchers';
    const forceLabel = isStretcher || showTDBF ? 'TDBF' : 'LDBF';
    
    return (
      <div className="main-product__table ordering-table ordering-table--with-description">
        <table>
          <thead>
            <tr>
              <th>Part number</th>
              <th>Part description</th>
              <th className="print-only">Diameter [mm]</th>
              <th>{forceLabel} [kN] up&nbsp;to:</th>
              <th>{forceLabel} [mt] up&nbsp;to:</th>
            </tr>
          </thead>
          <tbody>
            {orderingItems.map (item => (
              <tr key={item.Id}>
                <td>{item.Number}</td>
                <td>{item.Description}</td>
                <td className="print-only">{item.Diameter}</td>
                <td>{item.LDBFMaxInkN}</td>
                <td>{RoundTo1Decimal (kNIntoTons (item.LDBFMaxInkN))}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
